module.exports = __webpack_public_path__ + "img/serviceXCareMaintenance.ffb29d05.png";